export default __webpack_public_path__ + "static/media/habano-6Open.bf121283.jpg";